import { useEffect } from "react";
import { css } from "@emotion/react";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

import { CommentItem } from "../atoms";
import {
  hara_hiroto_comment,
  hara_hiroto_profile,
  yuzuki_yuko_comment,
  yuzuki_yuko_profile,
} from "../../constants/comments";

import { fadeInAnimation, fadeInVariants } from "../../constants/animations";

const Staff = () => {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [controls, inView]);

  // Top-Comment
  const topCommentControls = useAnimation();
  const [topCommentRef, topCommentInView] = useInView();
  useEffect(() => {
    if (topCommentInView) {
      topCommentControls.start("visible");
    }
  }, [topCommentControls, topCommentInView]);

  // Bottom-Comment
  const bottomCommentControls = useAnimation();
  const [bottomCommentRef, bottomCommentInView] = useInView();
  useEffect(() => {
    if (bottomCommentInView) {
      bottomCommentControls.start("visible");
    }
  }, [bottomCommentControls, bottomCommentInView]);

  return (
    <div css={mainStyle} id="staff">
      <motion.div
        ref={ref}
        css={titleStyle}
        initial="hidden"
        animate={controls}
        variants={fadeInVariants}
      >
        STAFF
      </motion.div>
      <motion.div
        ref={topCommentRef}
        initial="hidden"
        animate={topCommentControls}
        variants={fadeInVariants}
        css={commentItemWrapperStyle}
      >
        <CommentItem
          title="原作：柚月裕子"
          comment={yuzuki_yuko_comment}
          profile={yuzuki_yuko_profile}
          wrapperStyle={commentItemStyle(30, 30)}
        />
      </motion.div>
      <motion.div
        ref={bottomCommentRef}
        initial="hidden"
        animate={bottomCommentControls}
        variants={fadeInVariants}
        css={commentItemWrapperStyle}
      >
        <CommentItem
          title="監督：原廣利"
          comment={hara_hiroto_comment}
          profile={hara_hiroto_profile}
          wrapperStyle={commentItemStyle(50, 40)}
        />
      </motion.div>
    </div>
  );
};

const spSize = 768;

const mainStyle = css`
  position: relative;
  background-image: url(${process.env.REACT_APP_BASE_PATH +
  "/img/_bg-night-sakura.jpg"});
  background-size: cover;
  width: 100%;
  padding: 40px 0 60px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  @media (max-width: ${spSize}px) {
    padding: 30px 0 40px;
  }
`;

const titleStyle = css`
  font-size: 35px;
  font-weight: 500;
  letter-spacing: 0.075em;

  @media (max-width: ${spSize}px) {
    font-size: 20px;
    font-weight: 400;
  }
`;

const commentItemWrapperStyle = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const commentItemStyle = (marginTop: number, marginTopSP: number) => css`
  max-width: 800px;
  margin-top: ${marginTop}px;

  @media (max-width: ${spSize}px) {
    max-width: 80%;
    margin-top: ${marginTopSP}px;
  }
`;

export default Staff;
